module.exports = __webpack_public_path__ + "static/media/0.7b8406a4.jpg";